export default {
    game_id: "wanted",
    gameName : "Wanted",

    stageWidth: 1280,
    stageHeight: 720,

    scripts: [
        'framework/src/vendor/jquery.min.js',
        'framework/src/vendor/tween.js',
        'framework/src/vendor/ph.js',
    ],

    game: {
        audio: {
            tracks: [
                {
    name: 'Jackpot_sound',
    classVol: 'volume.normalWin',
    loop: false,
},
{
    name: 'JokerBonus_alert',
    classVol: 'volume.normalWin',
    loop: false,
},
            ]
        },
        freespins: {
            autostart: true
        },
        webfonts: [
            {className: "gomarice_tanomuze_cowboy"},
            "UbuntuMono-Regular", "Audiowide-Regular",

	]
    },
    system: {
        audio: {
            tracks: []
        }
    }
}
